(function () {
  var desk = window.matchMedia('(min-width: 1024px)');

  function init() {
    var root = document.getElementById('forge-collection');
    if (!root || root.dataset.fInit === '1') return;
    root.dataset.fInit = '1';

    var SWAP = ['[data-f-main]', '[data-f-chips]', '[data-f-count]', '[data-f-form]', '.f-rail__bar', '.f-rail__foot', '[data-f-badge]'];
    var inFlight = null;
    var observer = null;

    function openFacetKeys() {
      return Array.prototype.map.call(root.querySelectorAll('[data-f-facet][open]'), function (d) { return d.dataset.fFacet; });
    }

    function closeFacets(except) {
      root.querySelectorAll('[data-f-facet][open]').forEach(function (d) { if (d !== except) d.open = false; });
    }

    function applyUrl(url, push) {
      if (inFlight) inFlight.abort();
      var controller = new AbortController();
      inFlight = controller;
      var keep = openFacetKeys();
      root.classList.add('is-loading');
      fetch(url, { signal: controller.signal })
        .then(function (r) { if (!r.ok) throw new Error('bad'); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('forge-collection');
          if (!fresh) { window.location.href = url; return; }
          SWAP.forEach(function (sel) {
            var next = fresh.querySelector(sel), cur = root.querySelector(sel);
            if (next && cur) cur.replaceWith(next);
            else if (cur && !next) cur.remove();
            else if (next && !cur && sel === '[data-f-badge]') {
              var btn = root.querySelector('[data-f-rail-open]'); btn && btn.appendChild(next);
            }
          });
          keep.forEach(function (k) {
            var d = root.querySelector('[data-f-facet="' + k + '"]'); if (d) d.open = true;
          });
          var freshTitle = doc.querySelector('title'); if (freshTitle) document.title = freshTitle.textContent;
          if (push) window.history.pushState({ forge: true }, '', url);
          root.classList.remove('is-loading');
          inFlight = null;
          bindAll();
        })
        .catch(function (err) { if (!err || err.name !== 'AbortError') window.location.href = url; });
    }

    function urlFromForm() {
      var form = root.querySelector('[data-f-form]');
      if (!form) return null;
      var data = new FormData(form), params = new URLSearchParams();
      data.forEach(function (v, k) { if (v !== '' && v !== null) params.append(k, v); });
      var qs = params.toString();
      return window.location.pathname + (qs ? '?' + qs : '');
    }

    function bindForm() {
      var form = root.querySelector('[data-f-form]');
      if (!form || form.dataset.fBound === '1') return;
      form.dataset.fBound = '1';
      form.addEventListener('change', function (e) {
        if (e.target.type === 'range' || e.target.type === 'number') return;
        var url = urlFromForm(); url && applyUrl(url, true);
      });
      var t;
      form.addEventListener('input', function (e) {
        if (e.target.type !== 'number') return;
        clearTimeout(t);
        t = setTimeout(function () { var url = urlFromForm(); url && applyUrl(url, true); }, 600);
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); var url = urlFromForm(); url && applyUrl(url, true); });
    }

    function bindFacets() {
      root.querySelectorAll('[data-f-facet]').forEach(function (d) {
        if (d.dataset.fBound === '1') return;
        d.dataset.fBound = '1';
        d.addEventListener('toggle', function () { if (d.open && desk.matches) closeFacets(d); });
      });
    }

    function bindPrice() {
      var box = root.querySelector('[data-f-price]');
      if (!box || box.dataset.fBound === '1') return;
      box.dataset.fBound = '1';
      var lo = box.querySelector('[data-f-price-lo]'), hi = box.querySelector('[data-f-price-hi]'), fill = box.querySelector('[data-f-price-fill]');
      var inLo = root.querySelector('[data-f-price-in-lo]'), inHi = root.querySelector('[data-f-price-in-hi]');
      var floor = parseFloat(box.dataset.min) || 0, ceil = parseFloat(box.dataset.max) || 0;
      if (ceil <= floor) return;
      function paint() {
        var a = Math.min(+lo.value, +hi.value), b = Math.max(+lo.value, +hi.value), span = ceil - floor;
        fill.style.left = ((a - floor) / span * 100) + '%';
        fill.style.width = ((b - a) / span * 100) + '%';
      }
      function clamp(moved) { var a = +lo.value, b = +hi.value; if (a > b) { if (moved === lo) hi.value = a; else lo.value = b; } }
      function sync(moved) {
        clamp(moved); paint();
        if (inLo) inLo.value = (+lo.value === floor) ? '' : lo.value;
        if (inHi) inHi.value = (+hi.value === ceil) ? '' : hi.value;
      }
      [lo, hi].forEach(function (el) {
        el.addEventListener('input', function () { sync(el); });
        el.addEventListener('change', function () { sync(el); var url = urlFromForm(); url && applyUrl(url, true); });
      });
      [[inLo, lo], [inHi, hi]].forEach(function (p) {
        if (!p[0]) return;
        p[0].addEventListener('input', function () { var v = parseFloat(p[0].value); if (!isNaN(v)) { p[1].value = Math.min(Math.max(v, floor), ceil); clamp(p[1]); paint(); } });
      });
      paint();
    }

    function bindLinks() {
      var chips = root.querySelector('[data-f-chips]');
      if (chips && chips.dataset.fBound !== '1') {
        chips.dataset.fBound = '1';
        chips.addEventListener('click', function (e) {
          var a = e.target.closest('a'); if (!a) return;
          e.preventDefault(); applyUrl(a.getAttribute('href'), true);
        });
      }
      root.querySelectorAll('.f-rail__clear, .f-rail__clear-btn, [data-f-reset]').forEach(function (a) {
        if (a.dataset.fBound === '1') return;
        a.dataset.fBound = '1';
        a.addEventListener('click', function (e) {
          e.preventDefault();
          if (!a.hasAttribute('data-f-reset')) closeRail();
          applyUrl(a.getAttribute('href'), true);
        });
      });
    }

    function bindSort() {
      var wrap = root.querySelector('[data-f-sort]');
      if (!wrap || wrap.dataset.fBound === '1') return;
      wrap.dataset.fBound = '1';
      var select = wrap.querySelector('[data-f-sort-select]'), trigger = wrap.querySelector('[data-f-sort-trigger]'), panel = wrap.querySelector('[data-f-sort-panel]'), current = wrap.querySelector('[data-f-sort-current]');
      function open() { closeFacets(); panel.hidden = false; requestAnimationFrame(function () { wrap.classList.add('is-open'); }); trigger.setAttribute('aria-expanded', 'true'); }
      function close() { wrap.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); setTimeout(function () { if (!wrap.classList.contains('is-open')) panel.hidden = true; }, 180); }
      trigger.addEventListener('click', function () { wrap.classList.contains('is-open') ? close() : open(); });
      document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      panel.querySelectorAll('[data-f-sort-opt]').forEach(function (opt) {
        opt.addEventListener('click', function () {
          var v = opt.dataset.value;
          panel.querySelectorAll('[data-f-sort-opt]').forEach(function (o) { o.classList.remove('is-selected'); o.setAttribute('aria-selected', 'false'); });
          opt.classList.add('is-selected'); opt.setAttribute('aria-selected', 'true');
          current.textContent = opt.querySelector('.f-sortd__opt-text').textContent;
          select.value = v;
          close();
          var params = new URLSearchParams(window.location.search);
          params.set('sort_by', v);
          applyUrl(window.location.pathname + '?' + params.toString(), true);
        });
      });
      select.addEventListener('change', function () {
        var params = new URLSearchParams(window.location.search);
        params.set('sort_by', select.value);
        applyUrl(window.location.pathname + '?' + params.toString(), true);
      });
    }

    /* Infinite scroll: the next page loads as the end of the grid comes near. The link stays in the markup as a no-JS fallback. */
    var PRELOAD = 900;

    function scrollRoot() {
      var pw = document.querySelector('.page-wrapper');
      return pw && /(auto|scroll)/.test(getComputedStyle(pw).overflowY) ? pw : null;
    }

    function nearEnd() {
      var box = root.querySelector('[data-f-loadmore]');
      if (!box) return false;
      var sr = scrollRoot(), bottom = sr ? sr.getBoundingClientRect().bottom : window.innerHeight;
      return box.getBoundingClientRect().top < bottom + PRELOAD;
    }

    function loadNext() {
      var btn = root.querySelector('[data-f-loadmore-btn]');
      if (!btn || btn.classList.contains('is-loading')) return;
      var url = btn.dataset.nextUrl;
      var grid = root.querySelector('[data-f-grid]');
      btn.classList.add('is-loading');
      var skeletons = [];
      for (var i = 0; i < 4; i++) { var sk = document.createElement('div'); sk.className = 'f-card f-card--skeleton'; sk.setAttribute('aria-hidden', 'true'); grid.appendChild(sk); skeletons.push(sk); }
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshGrid = doc.querySelector('#forge-collection [data-f-grid]');
        skeletons.forEach(function (n) { n.remove(); });
        if (!btn.isConnected) return;
        if (freshGrid) {
          Array.prototype.forEach.call(freshGrid.children, function (node) { var c = node.cloneNode(true); c.classList.add('f-card--entering'); grid.appendChild(c); });
          requestAnimationFrame(function () { requestAnimationFrame(function () { grid.querySelectorAll('.f-card--entering').forEach(function (n) { n.classList.remove('f-card--entering'); }); }); });
        }
        var freshBtn = doc.querySelector('#forge-collection [data-f-loadmore-btn]');
        var total = parseInt(btn.dataset.total, 10) || 0;
        var loaded = freshBtn ? parseInt(freshBtn.dataset.loaded, 10) : total;
        var shown = root.querySelector('[data-f-shown]'), fill = root.querySelector('[data-f-fill]'), progress = root.querySelector('[data-f-progress]');
        if (fill) fill.style.width = Math.min(100, loaded / total * 100) + '%';
        if (freshBtn && freshBtn.dataset.nextUrl) {
          btn.dataset.nextUrl = freshBtn.dataset.nextUrl; btn.setAttribute('href', freshBtn.dataset.nextUrl); btn.dataset.loaded = loaded;
          if (shown) shown.textContent = loaded;
          btn.classList.remove('is-loading');
          requestAnimationFrame(function () { if (nearEnd()) loadNext(); });
        } else {
          if (progress) progress.textContent = 'Showing all ' + total + ' products';
          btn.remove();
          if (observer) { observer.disconnect(); observer = null; }
        }
      }).catch(function () { skeletons.forEach(function (n) { n.remove(); }); btn.classList.remove('is-loading'); btn.style.display = ''; });
    }

    function bindLoadMore() {
      if (observer) { observer.disconnect(); observer = null; }
      var btn = root.querySelector('[data-f-loadmore-btn]'), box = root.querySelector('[data-f-loadmore]');
      if (!btn || !box) return;
      if (btn.dataset.fBound !== '1') {
        btn.dataset.fBound = '1';
        btn.addEventListener('click', function (e) { e.preventDefault(); loadNext(); });
      }
      if (!('IntersectionObserver' in window)) return;
      btn.style.display = 'none';
      observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) loadNext();
      }, { root: scrollRoot(), rootMargin: '0px 0px ' + PRELOAD + 'px 0px' });
      observer.observe(box);
    }

    function bindView() {
      var btns = root.querySelectorAll('[data-f-view]');
      if (!btns.length) return;
      function set(v) {
        root.setAttribute('data-view', v);
        btns.forEach(function (b) { var on = b.dataset.fView === v; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      }
      var saved = null;
      try { saved = localStorage.getItem('forge_grid_view'); } catch (e) {}
      set(saved === 'alt' ? 'alt' : 'default');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          set(b.dataset.fView);
          try { localStorage.setItem('forge_grid_view', b.dataset.fView); } catch (e) {}
          requestAnimationFrame(function () { if (nearEnd()) loadNext(); });
        });
      });
    }

    function openRail() {
      var rail = root.querySelector('[data-f-rail]'), scrim = root.querySelector('.f-col__scrim');
      if (!rail) return;
      rail.classList.add('is-open'); if (scrim) scrim.hidden = false; document.body.classList.add('f-rail-open');
      var t = root.querySelector('[data-f-rail-open]'); t && t.setAttribute('aria-expanded', 'true');
    }
    function closeRail() {
      var rail = root.querySelector('[data-f-rail]'), scrim = root.querySelector('.f-col__scrim');
      if (!rail) return;
      rail.classList.remove('is-open'); if (scrim) scrim.hidden = true; document.body.classList.remove('f-rail-open');
      var t = root.querySelector('[data-f-rail-open]'); t && t.setAttribute('aria-expanded', 'false');
    }

    document.addEventListener('click', function (e) {
      if (!root.isConnected) return;
      if (e.target.closest('[data-f-rail-open]')) { e.preventDefault(); openRail(); return; }
      if (e.target.closest('[data-f-rail-close]')) { e.preventDefault(); closeRail(); return; }
      if (desk.matches && !e.target.closest('[data-f-facet]')) closeFacets();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeRail(); closeFacets(); } });
    window.addEventListener('popstate', function () { if (root.isConnected) applyUrl(window.location.pathname + window.location.search, false); });
    desk.addEventListener && desk.addEventListener('change', function () { closeFacets(); closeRail(); bindLoadMore(); });

    function bindAll() { bindForm(); bindFacets(); bindPrice(); bindLinks(); bindSort(); bindLoadMore(); }
    bindAll();
    bindView();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();